import { SearchComponent } from '@geogirafe/lib-geoportal/components';
import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';
import MySearchIcon from './images/search.svg';
import MyPaintbrushIcon from './images/paintbrush.svg';
import customCss from './style.css?inline';

GirafeHTMLElement.setCustomStyle('search', customCss);

// TODO: Remove custom component once the images have been moved to GeoGirafe's icons folder.

export default class MapbsSearchComponent extends SearchComponent {
  public override searchIcon: string = MySearchIcon;
  public override paintbrushIcon: string = MyPaintbrushIcon;
}
